import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import './Modal.css';

export function Modal({ open, onClose, title, footer, size = 'md', children, className = '' }) {
  const handleEsc = useCallback((e) => {
    if (e.key === 'Escape') onClose?.();
  }, [onClose]);

  useEffect(() => {
    if (open) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [open, handleEsc]);

  if (!open) return null;

  return createPortal(
    <div className="ui-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className={`ui-modal ui-modal--${size} ${className}`}>
        {title && (
          <div className="ui-modal__header">
            <h3 className="ui-modal__title">{title}</h3>
            <button className="ui-modal__close" onClick={onClose} aria-label="Закрыть">
              <X size={18} />
            </button>
          </div>
        )}
        <div className="ui-modal__body">{children}</div>
        {footer && <div className="ui-modal__footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}
